module.exports = __webpack_public_path__ + "img/youtube-icon.383cdfb5.svg";